import React, { FC, Fragment } from 'react';
import DocumentButtons from './components/DocumentButtons';

interface Props {
  docPrices?: boolean;
  isInformatique?: boolean;
  openDocument: (type?: 'technical' | 'orderForm') => void;
  toggleDoc: () => void;
}

const SubNavBarActions: FC<Props> = ({ openDocument, toggleDoc, docPrices, isInformatique }) => {
  return (
    <Fragment>
      <span className='mr-1'>Prix unitaire </span>
      <label className='switch mr-3'>
        <input defaultChecked={docPrices} onChange={toggleDoc} id='btnToggleBillingDoc' type='checkbox' />
        <div className='slider round'></div>
      </label>
      {isInformatique ? (
        <DocumentButtons openDocument={openDocument} />
      ) : (
        <button onClick={() => openDocument()} type='button' className='btn btn-sm btn-outline-success'>
          <span className='icon icon-document'>Document</span>
        </button>
      )}
    </Fragment>
  );
};

export default SubNavBarActions;
